import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=0442614e&scoped=true"
import script from "./SmallCard.vue?vue&type=script&lang=js"
export * from "./SmallCard.vue?vue&type=script&lang=js"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=0442614e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442614e",
  null
  
)

export default component.exports